import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type SettlementType = 'cod' | 'pay' | 'tenant_payout' | 'refund';

interface SettlementTypeBadgeProps {
  type: SettlementType;
  className?: string;
}

const typeConfig: Record<SettlementType, { labelAr: string; labelEn: string; className: string }> = {
  cod: {
    labelAr: 'نقدية',
    labelEn: 'COD',
    className: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-800',
  },
  pay: {
    labelAr: 'أجر',
    labelEn: 'Pay',
    className: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-800',
  },
  tenant_payout: {
    labelAr: 'تسوية تاجر',
    labelEn: 'Tenant Payout',
    className: 'bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-950 dark:text-purple-300 dark:border-purple-800',
  },
  refund: {
    labelAr: 'مرتجع',
    labelEn: 'Refund',
    className: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-300 dark:border-red-800',
  },
};

export function SettlementTypeBadge({ type, className }: SettlementTypeBadgeProps) {
  const config = typeConfig[type];
  return (
    <Badge variant="outline" className={cn(config.className, className)}>
      {config.labelAr}
    </Badge>
  );
}
